import React from 'react'

import { AiOutlineUser } from 'react-icons/ai'

import { AdminContext } from 'contexts/AdminContext'

import MenuItem from './MenuItem'

import MenuConfig from './../MenuConfig'

const AppSidebar = () => {
  const __adminContext = React.useContext(AdminContext)

  const menuConfigValido = React.useMemo(() => {
    const leerSubMenu = __subMenu => {
      let tempSalida = []

      for (let i = 0; i < __subMenu.length; i++) {
        const subMen = __subMenu[i]

        if (!!subMen.submenu) {
          const resultadoNAvegacioon = leerSubMenu(subMen.submenu)
          if (resultadoNAvegacioon && resultadoNAvegacioon.length > 0) {
            tempSalida.push({
              ...subMen,
              submenu: resultadoNAvegacioon
            })
          }
        } else {
          if (__adminContext.transacciones.some(x => x === subMen.transaccion)) {
            tempSalida.push(subMen)
          }
        }
      }

      return tempSalida
    }

    const leerArray = __array => {
      const salida = []

      for (let i = 0; i < __array.length; i++) {
        const element = __array[i]

        if (element.page && __adminContext.transacciones.some(x => x === element.transaccion)) {
          salida.push(element)
        } else if (!!element.submenu) {
          const salidaSubMenu = leerSubMenu(element.submenu)
          if (salidaSubMenu && salidaSubMenu.length > 0) {
            salida.push({
              ...element,
              submenu: salidaSubMenu
            })
          }
        }
      }

      return salida
    }

    const nuevosItems = leerArray(MenuConfig)

    return nuevosItems || []
  }, [__adminContext.transacciones])

  const menuHtml = React.useMemo(() => {
    const construirRoot = __array => {
      const salida = []

      for (let i = 0; i < __array.length; i++) {
        const element = __array[i]

        if (!element.submenu || element.submenu.length === 0) {
          salida.push(<MenuItem name={element.title} page={element.page} />)
        } else {
          salida.push(<MenuItem name={element.title} subMenuInfo={element.submenu} />)
        }
      }

      return salida
    }

    const menuConstruido = construirRoot(menuConfigValido)

    return menuConstruido || []
  }, [menuConfigValido])

  return (
    <div className='app-sidebar'>
      <div className='sidebar-user'>
        <div className='user-body'>
          <AiOutlineUser />
        </div>
        <div className='user-info'>
          <a href='#!'>
            <span className='info-name'>{__adminContext.usuario}</span>
            {/* <br />
            <span className='info-role'>Administrador</span> */}
          </a>
        </div>
      </div>
      <ul className='sidebar-menu'>{menuHtml}</ul>
    </div>
  )
}

export default React.memo(AppSidebar)
